<section class="row makePaymentView" id="productList-area">
  <aside class="col-md-3 col-sm-3 col-lg-2 col-xs-12 applied-filter pr-0">
    <fieldset id="filter-by">
      <legend class="filterByTitle-main order-history-search">
        {{ "ordersList.searchBy" | cxTranslate }}
      </legend>
      <div class="grey-line"></div>
      <div class="filterByGroup mb-3">
        <div class="filterByTitle">
          <label for="invoice">
            {{'customerService.selectType'|cxTranslate}}
          </label>
        </div>
        <ng-select
        [items]="ticketTypeList"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
        name="selectedType"
        [(ngModel)]="selectedType"
        [searchable]="false"
        class="dropdown-credit"
      >
        </ng-select>
      </div>
      <div class="filterByGroup mb-3">
        <div class="filterByTitle">
          <label for="invoice">
            Status
          </label>
        </div>
        <ng-select
        [items]="ticketStatusList"
        bindLabel="name"
        bindValue="code"
        [multiple]="false"
        name="selectedStatus"
        [(ngModel)]="selectedStatus"
        [searchable]="false"
        class="dropdown-credit"
      >
        </ng-select>
      </div>
      <div class="filterByGroup mb-3">
        <div class="filterByTitle">
          <label for="invoice">
            Nº Ticket
          </label>
        </div>
        <label class="searchbox orders-filter time-frame">
        <input
        type="text"
        autocomplete="off"
        aria-describedby="initialDescription"
        aria-controls="results"
        aria-autocomplete="both"
        class="input-filter"
        [(ngModel)]="ticketId"
        placeholder="Procure seu ticket"
      />
    </label>
      </div>
      <div class="account-order-filter-btn">
        <button
          type="submit"
          class="btn btn-default blue-button"
          data-di-id="di-id-362f2c77-5f23e741"
          (click)="applyFilter()"
        >
          {{ "ordersList.applyFilters" | cxTranslate }}
        </button>
        <button
          type="button"
          id="clearOrderFiltersBtn"
          class="btn btn-default white-button"
          data-di-id="#clearOrderFiltersBtn"
          (click)="clearFilters()"
        >
          {{ "ordersList.clearFilters" | cxTranslate }}
        </button>
      </div>
    </fieldset>
    <div class="line-intersection"></div>
  </aside>
  <section class="col-md-9 col-sm-9 col-lg-10 table-s-section float-right">
    <section class="filter-section">
      <section class="row">
        <section class="col-sm-12 col-md-12 col-md-12 col-xs-12 op_ovice">
          <div id="filter-applied" class="applied-filter">
            <div class="row row-20 page-section">
              <div class="col-md-8 col-sm-7 hidden-xs filterApply-showing">
                <span
                  >{{ "ordersList.showing" | cxTranslate }}
                  {{
                    (ticketDetails?.pagination?.pageSize <
                    ticketDetails?.pagination?.totalResults)
                      ? (ticketDetails?.pagination?.currentPage>0?(((ticketDetails?.pagination?.pageSize)*(ticketDetails?.pagination?.currentPage+1) < ticketDetails?.pagination?.totalResults)?(ticketDetails?.pagination?.pageSize)*(ticketDetails?.pagination?.currentPage+1):ticketDetails?.pagination?.totalResults):ticketDetails?.pagination?.pageSize)
                      : ticketDetails?.pagination?.totalResults
                  }}
                  {{ "ordersList.of" | cxTranslate }}
                  {{ ticketDetails?.pagination?.totalResults }}
                  ingressos</span
                >
              </div>
              <div class="col-md-4 col-sm-5 top-pagination left-pagination">
                <div class="time-frame">
                  <span class="top-page-id mr-2 pt-1" id="accPageInfo"
                    >{{ "ordersList.page" | cxTranslate }}
                    {{
                      ticketDetails?.pagination?.totalPages > 0
                        ? ticketDetails?.pagination?.currentPage + 1
                        : 0
                    }}
                    {{ "ordersList.of" | cxTranslate }}
                    {{
                      ticketDetails?.pagination?.totalPages
                        ? ticketDetails?.pagination?.totalPages
                        : 0
                    }}</span
                  >
                  <div class="pagination">
                    <button
                      class="pagination-btns mr-1"
                      [disabled]="
                        !ticketDetails?.pagination ||
                        ticketDetails?.pagination?.currentPage === 0
                      "
                      (click)="paginationPrev()"
                    >
                      <span class="chevronIconWhite prev"></span>
                    </button>
                    <button
                      class="pagination-btns"
                      [disabled]="
                        ticketDetails?.pagination?.currentPage + 1 ===
                          ticketDetails?.pagination?.totalPages ||
                        ticketDetails?.pagination?.totalPages === 0 ||
                        !ticketDetails?.pagination
                      "
                      (click)="paginationNext()"
                    >
                      <span class="chevronIconWhite next"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr class="hidden-xs" />
            <div
              class="row row-20"
              [ngClass]="
                facetsList?.length > 2 ? 'page-dropdown-ipad' : 'page-dropdown'
              "
            >
              <div class="col-md-8 col-sm-7 hidden-xs applied-filters">
                {{ "ordersList.filtersApplied" | cxTranslate }}
                <span *ngIf="!facetsList?.length">{{
                  "ordersList.none" | cxTranslate
                }}</span>
                <span id="applied-filters" class="ml-2">
                  <span
                    class="filterText focus mr-1 mb-2"
                    tabindex="0"
                    *ngFor="let filter of facetsList"
                  >
                    <div>
                      {{ filter?.value
                      }}<img
                        src="../../../assets/icons/white close.png"
                        alt=""
                        class="remove-facet"
                        (click)="removeFacet(filter)"
                      />
                      <span class="filterRemove"></span>
                    </div> </span
                  ><a
                    class="clear-filters ml-1"
                    (click)="clearFilters()"
                    *ngIf="facetsList?.length"
                    >{{ "ordersList.clearAllFilters" | cxTranslate }}</a
                  >
                </span>
              </div>
              <div class="col-md-4 col-sm-5 col-xs-12 sortBy-select px-12">
                <ng-select
                  name="pageSize"
                  [items]="pageList"
                  [searchable]="false"
                  [clearable]="false"
                  bindLabel="name"
                  bindValue="code"
                  class="set-pagination"
                  [(ngModel)]="pageSizeperPage"
                  (change)="changePageSize()"
                ></ng-select>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>

    <section class="payment-section filter-section">
      <section class="dispaly-refine">
        <ng-template #facetsRwd class="select-refine">
          <section class="modal-class">
            <section class="modal-heading">
              <h2>
                <span class="close-icon" aria-hidden="true" (click)="hide()"
                >&times;</span
              >
              </h2>
              <h2 class="select-heading">
                {{ "plp.selectRefinement" | cxTranslate }}
              </h2>
            </section>
            <section>
              <fieldset id="filter-by">
                <legend class="filterByTitle-main order-history-search">
                  {{ "ordersList.searchBy" | cxTranslate }}
                </legend>
                <div class="filterByGroup mb-3">
                <div class="filterByTitle">
                  <label for="invoice">
                    {{'customerService.selectType'|cxTranslate}}
                  </label>
                </div>
                <ng-select
                [items]="ticketTypeList"
                bindLabel="name"
                bindValue="id"
                [multiple]="false"
                name="selectedType"
                [(ngModel)]="selectedType"
                [searchable]="false"
                class="dropdown-credit"
              >
                </ng-select>
              </div>
              <div class="filterByGroup mb-3">
                <div class="filterByTitle">
                  <label for="invoice">
                    Status
                  </label>
                </div>
                <ng-select
                [items]="ticketStatusList"
                bindLabel="name"
                bindValue="code"
                [multiple]="false"
                name="selectedStatus"
                [(ngModel)]="selectedStatus"
                [searchable]="false"
                class="dropdown-credit"
              >
                </ng-select>
              </div>
              <div class="filterByGroup mb-3">
                <div class="filterByTitle">
                  <label for="invoice">
                    Nº Ticket
                  </label>
                </div>
                <label class="searchbox orders-filter time-frame">
                  <input
                  type="text"
                  autocomplete="off"
                  aria-describedby="initialDescription"
                  aria-controls="results"
                  aria-autocomplete="both"
                  class="input-filter"
                  [(ngModel)]="ticketId"
                  placeholder="Procure seu ticket"
                />
            </label>
              </div>
              <div class="account-order-filter-btn">
                <button
                  type="submit"
                  class="btn btn-default blue-button"
                  data-di-id="di-id-362f2c77-5f23e741"
                  (click)="applyFilter(0)"
                >
                  {{ "ordersList.applyFilters" | cxTranslate }}
                </button>
                <button
                  type="button"
                  id="clearOrderFiltersBtn"
                  class="btn btn-default white-button"
                  data-di-id="#clearOrderFiltersBtn"
                  (click)="clearFilters()"
                >
                  {{ "ordersList.clearFilters" | cxTranslate }}
                </button>
              </div>
              </fieldset>
            </section>
          </section>
        </ng-template>
        <div class="account-order-filter-btn mb-1">
          <button
          class="btn btn-default white-button"
          data-di-id="#refineBtn"
          (click)="refine()"
        >
          {{ "ordersList.refine" | cxTranslate }}
        </button>
        </div>
        <div class="sortBy-select pb-4 mobile-view-select">
          <ng-select
          name="pageSize"
          [items]="pageList"
          [searchable]="false"
          [clearable]="false"
          bindLabel="name"
          bindValue="code"
          class="dropdown-credit set-pagination"
          [(ngModel)]="pageSizeperPage"
          (ngModelChange)="changePageSize()"
        ></ng-select>
        </div>
        <div>
        <span>{{ "ordersList.totalRecords" | cxTranslate }}={{ticketDetails?.pagination?.totalResults?ticketDetails?.pagination?.totalResults:0}}</span>
        <a
        aria-label="download order history as"
        id="orderXLSRWD"
        (click)="generateXls()"
      >
        <img
          src="../../../assets/icons/MicrosoftTeams-image.png"
          alt="pdf"
          class="ad-pdf xls-img"
        />
        <span></span>
        <span class="pdf-text pl-1">{{
          "ordersList.xls" | cxTranslate
        }}</span>
      </a>
      </div>
      </section>
      <section class="pb-4">
        <div class="col-xs-12 ad-files-text">
          <a
            aria-label="download order history as"
            id="orderXLS"
            (click)="generateXls()"
          >
            <img
              src="../../../assets/icons/MicrosoftTeams-image.png"
              alt="pdf"
              class="ad-pdf xls-img"
            />
            <span></span>
            <span class="pdf-text pl-1">{{
              "ordersList.xls" | cxTranslate
            }}</span>
          </a>
          <a
            aria-label="download order history as"
            id="orderPDF"
            (click)="generateSavePdf()"
          >
            <img src="../../assets/icons/pdf.png" alt="pdf" class="ad-pdf" />
            <span class="ad-pdf"></span>
            <span class="pdf-text">{{ "ordersList.pdf" | cxTranslate }}</span>
          </a>
        </div>
      </section>
      <table
        aria-describedby="invoicesTable"
        id="ordersTable"
        class="order-list-table table table-striped"
      >
        <thead>
          <tr>
            <th
              scope="col"
              class="date-title"
              (click)="
                sortColumn($event, 'id', ticketDetails?.tickets, 'Number')
              "
            >
              <!-- {{ "ordersList.b2bTableLabel" | cxTranslate }} -->
              Nº Ticket
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th
              scope="col"
              class="type-title"
              (click)="
                sortColumn(
                  $event,
                  'ticketCategory',
                  ticketDetails?.tickets,
                  'status'
                )
              "
            >
              <!-- {{ "ordersList.b2bNameTableLabel" | cxTranslate }} -->
              Tipo
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th
              scope="col"
              class="order-title"
              (click)="
                sortColumn($event, 'ticketSubType', ticketDetails?.tickets, 'normal')
              "
            >
              <!-- {{ "ordersList.b2bCusName" | cxTranslate }} -->
              Subtipo
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th
              scope="col"
              class="status-title"
              (click)="
                sortColumn($event, 'createdAt', ticketDetails?.tickets, 'Date')
              "
            >
              <!-- {{ "ordersList.email" | cxTranslate }} -->
              Submissão
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th
              scope="col"
              class="po-title"
              (click)="
                sortColumn($event, 'modifiedAt', ticketDetails?.tickets, 'Date')
              "
            >
              <!-- {{ "ordersList.userName" | cxTranslate }} -->
              Ultima atualização
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th
              scope="col"
              class="invoice-title"
              (click)="
                sortColumn($event, 'status', ticketDetails?.tickets, 'status')
              "
            >
              <!-- {{ "ordersList.userIDdis" | cxTranslate }} -->
              Status
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="tracking-title">
              <!-- {{ "ordersList.viewActionButton" | cxTranslate }} -->
              Cliente
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of ticketDetails?.tickets">
            <td>
              <span
                ><a (click)="viewTicket(data?.id)">{{ data?.id }}</a></span
              >
            </td>
            <td>
              <span>{{ data?.ticketCategory?.name }}</span>
            </td>
            <td>
              <span>{{ data?.ticketSubType }}</span>
            </td>
            <td>
              <span>{{
                data?.createdAt | slice: 0:10 | date: "dd/MM/yyyy"
              }}</span>
            </td>
            <td>
              <span>{{
                data?.modifiedAt | slice: 0:10 | date: "dd/MM/yyyy"
              }}</span>
            </td>
            <td>
              <span>{{ data?.status?.name }}</span>
            </td>
            <td>
              <span>{{ data?.b2bUnitName }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <section class="text-center" *ngIf="ticketDetails?.tickets?.length === 0">
        Você não tem ingressos
      </section>
      <section class="orders-table-orders">
        <div
          class="orders-row-table"
          *ngFor="let data of ticketDetails?.tickets"
        >
          <div class="column header-column orders-table-col">
            <section class="col-header-rwd">
              <p>
                <b> Nº Ticket </b>
              </p>
              <p>
                {{ data?.id }}
              </p>
              <p>
                <b> Tipo </b>
              </p>
              <p>
                {{ data?.ticketCategory?.name }}
              </p>
              <p>
                <b> Subtipo </b>
              </p>
              <p>
                {{ data?.ticketSubType }}
              </p>
              <p>
                <b> Submissão </b>
              </p>
              <p>
                {{ data?.createdAt | slice: 0:10 | date: "dd/MM/yyyy" }}
              </p>
              <p>
                <b> Ultima atualização </b>
              </p>
              <p>
                {{ data?.modifiedAt | slice: 0:10 | date: "dd/MM/yyyy" }}
              </p>
              <p>
                <b> Status </b>
              </p>
              <p>
                {{ data?.status?.name }}
              </p>
              <p>
                <b> Cliente </b>
              </p>
              <p>
                {{ data?.b2bUnitName }}
              </p>
            </section>
          </div>
        </div>
      </section>
    </section>
    <section>
      <div id="prod-pagination">
        <p>
          {{ "ordersList.showing" | cxTranslate }} &nbsp;
          <span class="no_rec">                  {{
            (ticketDetails?.pagination?.pageSize <
            ticketDetails?.pagination?.totalResults)
              ? (ticketDetails?.pagination?.currentPage>0?(((ticketDetails?.pagination?.pageSize)*(ticketDetails?.pagination?.currentPage+1) < ticketDetails?.pagination?.totalResults)?(ticketDetails?.pagination?.pageSize)*(ticketDetails?.pagination?.currentPage+1):ticketDetails?.pagination?.totalResults):ticketDetails?.pagination?.pageSize)
              : ticketDetails?.pagination?.totalResults
          }}</span
          >&nbsp; {{ "ordersList.of" | cxTranslate }} &nbsp;
          <span class="no_rec"> {{ ticketDetails?.pagination?.totalResults }}</span
          >&nbsp; ingressos
        </p>
        <p class="pagination align-btns">
          <button
          class="pagination-btns mr-1"
          [disabled]="
            !ticketDetails?.pagination ||
            ticketDetails?.pagination?.currentPage === 0
          "
          (click)="paginationPrev()"
        >
        <span class="chevronIconWhite prev"></span>
        </button>
        <button
        class="pagination-btns"
        [disabled]="
          ticketDetails?.pagination?.currentPage + 1 ===
            ticketDetails?.pagination?.totalPages ||
          ticketDetails?.pagination?.totalPages === 0 ||
          !ticketDetails?.pagination
        "
        (click)="paginationNext()"
      >
            <span class="chevronIconWhite next"></span>
          </button>
        </p>
        <p>
          <span
            >{{ "ordersList.page" | cxTranslate }} {{ticketDetails?.pagination?.totalPages > 0 ? ticketDetails?.pagination?.currentPage + 1 : 0}}
            {{ "ordersList.of" | cxTranslate }} {{
              ticketDetails?.pagination?.totalPages
                ? ticketDetails?.pagination?.totalPages
                : 0
            }}</span
          >
        </p>
      </div>
    </section>
    <section>
      <div class="top-pagination text-center dispaly-refine display-pag">
        <div class="">
          <span id="accPageInfo" class="top-page-id mr-2 pt-1"
            >Page
            {{
              ticketDetails?.pagination?.totalPages > 0
                ? ticketDetails?.pagination?.currentPage + 1
                : 0
            }}
            of
            {{
              ticketDetails?.pagination?.totalPages
                ? ticketDetails?.pagination?.totalPages
                : 0
            }}</span
          >
          <div class="">
            <button
              class="pagination-btns mr-1"
              [disabled]="
                !ticketDetails?.pagination ||
                ticketDetails?.pagination?.currentPage === 0
              "
              (click)="paginationPrev()"
            >
              <span class="chevronIconWhite prev"></span>
            </button>
            <button
              class="pagination-btns"
              [disabled]="
                ticketDetails?.pagination?.currentPage + 1 ===
                  ticketDetails?.pagination?.totalPages ||
                ticketDetails?.pagination?.totalPages === 0 ||
                !ticketDetails?.pagination
              "
              (click)="paginationNext()"
            >
              <span class="chevronIconWhite next"></span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="line-intersection mobile-view"></div>
  </section>
</section>
